// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    // while checking auth state, show a loader
    return <div>Loading...</div>;
  }

  if (!user) {
    // user is not logged in, redirect to home or login
    return <Navigate to="/" replace />;
  }

  // user is logged in, render the children
  return children;
}
